import { centsToDollars } from './currency-conversion'

export function formatCurrency(number: number, hardCentsConversion: boolean = false): string {
  return number % 100 !== 0 || hardCentsConversion
    ? formatterWithCents.format(centsToDollars(number))
    : formatter.format(centsToDollars(number))
}

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 0 // (causes 2500.99 to be printed as $2,501)
})

const formatterWithCents = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 2 // (causes 2500.99 to be printed as $2,501.99)
})
